
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcg/[slug]",
      function () {
        return require("private-next-pages/uxcg/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcg/[slug]"])
      });
    }
  